import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { http } from "../lib/api";
import { Building2, Users, ArrowUpRight, FileText } from "lucide-react";

export default function AdminComunidades() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  useEffect(() => {
    setLoading(true);
    http.get("/admin/clientes?tipo=comunidad")
      .then((r) => setItems(r.data || []))
      .finally(() => setLoading(false));
  }, []);

  const filtered = q.trim()
    ? items.filter((c) =>
        [c.nombre, c.rut, c.email, c.comuna, c.contacto_nombre]
          .filter(Boolean)
          .some((v) => v.toLowerCase().includes(q.toLowerCase()))
      )
    : items;

  return (
    <div data-testid="admin-comunidades">
      <div className="mb-6 flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Manrope" }}>
            Comunidades
          </h1>
          <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>
            Vista 360° de cada comunidad: pólizas, contactos, cobros y siniestros.
          </p>
        </div>
        <input
          className="field-input"
          placeholder="Buscar por nombre, RUT, comuna…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          style={{ maxWidth: 320 }}
          data-testid="comunidades-search"
        />
      </div>

      <div className="bg-white border rounded-xl overflow-hidden" style={{ borderColor: "var(--border-subtle)" }}>
        {loading ? (
          <div className="p-10 text-center text-sm" style={{ color: "var(--text-muted)" }}>Cargando…</div>
        ) : filtered.length === 0 ? (
          <div className="p-10 text-center">
            <Building2 size={36} className="mx-auto mb-3" style={{ color: "var(--text-muted)" }} />
            <div className="font-bold mb-1" style={{ fontFamily: "Manrope" }}>
              {items.length === 0 ? "No hay comunidades cargadas" : "Sin resultados"}
            </div>
            <div className="text-sm" style={{ color: "var(--text-muted)" }}>
              {items.length === 0 ? (
                <>Crea comunidades desde <Link to="/admin/clientes" className="font-bold" style={{ color: "var(--brand-accent)" }}>Clientes & Pólizas</Link>.</>
              ) : "Prueba con otro término."}
            </div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="tbl">
              <thead>
                <tr>
                  <th>Comunidad</th>
                  <th>RUT</th>
                  <th>Comuna</th>
                  <th>Contacto</th>
                  <th>Pólizas</th>
                  <th>Estado</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((c) => (
                  <tr key={c.id}>
                    <td className="font-semibold">
                      <Link to={`/admin/comunidades/${c.id}`} className="nav-link" data-testid={`comunidad-link-${c.id}`}>
                        {c.nombre}
                      </Link>
                      <div className="text-[11px]" style={{ color: "var(--text-muted)" }}>{c.email}</div>
                    </td>
                    <td className="text-[13px]">{c.rut}</td>
                    <td>{c.comuna || "—"}</td>
                    <td>
                      {c.contacto_nombre || "—"}
                      <div className="text-[11px]" style={{ color: "var(--text-muted)" }}>{c.contacto_rol}</div>
                    </td>
                    <td>{(c.polizas || []).length}</td>
                    <td>
                      <span className={`badge badge--${c.estado || "activo"}`}>{c.estado || "activo"}</span>
                    </td>
                    <td>
                      <Link to={`/admin/comunidades/${c.id}`} className="text-sm font-semibold inline-flex items-center gap-1" style={{ color: "var(--brand-accent)" }}>
                        Ver 360° <ArrowUpRight size={13} />
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
